import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { environment } from '@libs/environment';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@libs/shared/components/button/button.module';
import { Loan } from '@libs/models/loan.model';
import { PaymentHelper } from '@libs/shared/core/payment-helper';

@Component({
  selector: 'app-payment-button',
  templateUrl: `./templates/${environment.name}/page.html`,
  styleUrls: [`./templates/${environment.name}/style.sass`],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, ButtonModule],
  providers: [],
})
export class PaymentButtonComponent extends PaymentHelper {
  public type = input<'big' | 'small'>('big');
  public payment = input<{ visible: boolean, loan: Loan }>();
  public amount = computed(() => {
    const loan = this.payment().loan;
    return loan?.agreementDecrease?.amountToActivate ?? loan.debtAmount;
  });
  public id = computed(() => {
    const loan = this.payment().loan;
    return loan?.id;
  });
  public isBig = computed(() => this.type() === 'big');

  public pay(): void {
    this.loanPayment(this.id(), this.amount());
  }
}
